import React from 'react'
import { SUPPORTED_LOCALES } from '../../i18n'

const LOCALE_LABELS = {
  en: 'EN',
  de: 'DE',
}

export default function LocaleToggle({ locale, onChange, className = '' }) {
  return (
    <div className={`inline-flex rounded-lg border border-rb-widget-border dark:border-rb-dark-mode-lighter overflow-hidden ${className}`}>
      {SUPPORTED_LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          aria-pressed={locale === option}
          className={`px-3 py-1.5 text-sm font-medium cursor-pointer border-0 transition-colors ${
            locale === option
              ? 'bg-rb-green text-white'
              : 'bg-white dark:bg-rb-dark-mode text-rb-black dark:text-white hover:opacity-80'
          }`}
        >
          {LOCALE_LABELS[option]}
        </button>
      ))}
    </div>
  )
}
